import { Component } from 'react';
import cx from 'classnames';
import styles from '../../styles/details.scss';
import fieldStyles from '../../styles/field.scss';
import sliderStyles from '../../styles/plan/investmentCard.scss';
import { CDN_CLRSAVE_URL } from '../../constants';

interface Props {
  type: string;
  name: string;
  labelName?: string;
  id: string;
  as?: string;
  value?: any;
  isInvalid?: boolean;
  required?: boolean;
  options?: object;
  placeholder?: string;
  onChange?: any;
  className?: string;
  onBlur?: any;
  disabled?: boolean;
  hideEmpty?: boolean;
  validationMessage?: string;
  fieldType?: string;
  onFocus?: any;
  autoFocus?: boolean;
  isHidden?: boolean;
  inputRef?: any;
  mandate?: boolean;
  isSearchPage?: boolean;
  labelStyles?: string;
  minSliderValue?: number;
  maxSliderValue?: number;
  sliderStep?: string;
}

class Field extends Component<Props, any> {
  public render() {
    const { type, onChange, name, disabled, isHidden } = this.props;
    // return nulll if a field is hidden
    if (isHidden) {
      return null;
    }

    if (type === 'text') {
      let noMinHeightCls = false;
      if (this.props.className === 'no-min-height-input') {
        noMinHeightCls = true;
      }
      return (
        <TextField
          {...this.props}
          noMinHeight={noMinHeightCls}
          onChange={disabled ? () => null : onChange}
        />
      );
    } else if (type === 'radio') {
      return (
        <RadioField
          className={cx({
            [`large-12 ${styles['payment-select']}`]: name === 'paymentMode',
            'large-6 disable': disabled,
          })}
          {...this.props}
          onChange={disabled ? () => null : onChange}
        />
      );
    } else if (type === 'checkbox') {
      return (
        <CheckboxField
          {...this.props}
          onChange={disabled ? () => null : onChange}
        />
      );
    } else if (type === 'select') {
      return (
        <SelectBox
          {...this.props}
          onChange={disabled ? () => null : onChange}
        />
      );
    } else if (type === 'textarea') {
      return (
        <TextArea {...this.props} onChange={disabled ? () => null : onChange} />
      );
    } else if (type === 'toggle-switch') {
      return (
        <ToggleSwitch
          {...this.props}
          onChange={disabled ? () => null : onChange}
        />
      );
    } else if (type === 'slider') {
      return (
        <Slider {...this.props} onChange={disabled ? () => null : onChange} />
      );
    }
  }
}

export default Field;

const TextField = (props) => (
  <div
    className={cx(props.className || 'large-6', 'columns', {
      [styles.columns]: !props.noMinHeight,
    })}
  >
    <fieldset
      className={cx('f f-normal', styles['f-normal'], {
        [styles['bank-verify-modal-input']]: props.noMinHeight,
      })}
    >
      {props.labelName ? (
        <label
          className={cx(
            'f-label full-width',
            styles['f-label'],
            props.labelStyles
          )}
        >
          {props.labelName}
        </label>
      ) : null}
      <input
        value={props.value}
        name={props.name}
        placeholder={props.placeholder}
        onChange={props.onChange.bind(this)}
        onBlur={props.onBlur}
        type={props.fieldType || 'text'}
        className="full-width"
        id={props.id}
        ref={props.inputRef}
        onFocus={props.onFocus}
        autoFocus={props.autoFocus}
        required={props.required}
        disabled={props.disabled}
        maxLength={props.maxLength}
      />
      {props.isInvalid ? (
        <span className={styles['error']}>{props.validationMessage}</span>
      ) : null}
    </fieldset>
  </div>
);

const RadioField = (props) => (
  <div className={cx(props.className || 'large-6', 'columns', styles.columns)}>
    <label className={cx('label-for-input mb10')}>
      <span>{props.labelName}</span>
    </label>
    <div className="">
      {props.options.map((option) => {
        const isChecked =
          props.value.toLowerCase() === option.value.toLowerCase();
        const isPayment = props.name === 'paymentMode';
        if (isPayment && props.paymentModes.indexOf(option.value) === -1) {
          return;
        }
        return (
          <span key={option.value}>
            <label
              className={cx(styles['radio-fields'], {
                'large-12 small-12 payment-options-list': isPayment,
                [styles.checked]: isChecked,
                [styles['sort-options']]: props.isSearchPage,
                [styles.disabled]: option.disabled,
              })}
            >
              <span>
                <span
                  className={cx({
                    'radio-button': true,
                    checkmark: true,
                    [styles.hide]: isPayment,
                    checked: isChecked,
                  })}
                />
                <span className={cx({ 'payment-mode-label': isPayment })}>
                  {option.label}
                </span>
                <input
                  type="radio"
                  name={props.name}
                  onChange={props.onChange.bind(this)}
                  value={option.value}
                  checked={isChecked}
                  disabled={option.disabled}
                  required={props.required}
                  className="hide-radio"
                />
              </span>
              {isPayment ? (
                <img
                  className={cx('float--right')}
                  src={`${CDN_CLRSAVE_URL}\/${option.icon}`}
                  alt={option.icon}
                />
              ) : null}
            </label>
            {isPayment ? <hr /> : null}
          </span>
        );
      })}
      {props.isInvalid ? (
        <label className={cx(styles['error'], 'large-9 columns mt10')}>
          {props.validationMessage}
        </label>
      ) : null}
    </div>
  </div>
);

const CheckboxField = (props) => (
  <div
    className={cx(styles.columns, styles['nominee-check'], 'large-12 columns')}
  >
    <input
      name={props.name}
      type={props.type}
      onChange={props.onChange.bind(this)}
      value={props.value}
      checked={props.value}
    />
    &nbsp;&nbsp;
    <span>
      <strong>{props.labelName}</strong>
    </span>
  </div>
);

const ToggleSwitch = (props) => (
  <div
    className={cx(
      props.className || 'large-12 columns',
      styles.columns,
      'flex',
      'mb-30'
    )}
  >
    {props.labelName ? (
      <label
        className={cx('f-label', styles['f-label'], props.labelStyles, 'mr10')}
      >
        {props.labelName}
      </label>
    ) : null}
    <label className={cx(fieldStyles['switch'])}>
      <input
        type="checkbox"
        name={props.name}
        onChange={props.onChange.bind(this)}
        value={props.value}
        checked={props.value}
      />
      <span className={cx(fieldStyles['slider'], fieldStyles['round'])} />
    </label>
  </div>
);

const SelectBox = (props) => (
  <div
    className={cx(
      {
        [fieldStyles.paper]: props.mandate,
        [fieldStyles.mandate]: props.mandate,
        [styles.mandate]: props.mandate,
      },
      props.className || 'large-6 columns',
      styles.columns
    )}
  >
    <fieldset className={cx('f f-normal', styles['f-normal'])}>
      {props.labelName ? (
        <label
          className={cx('f-label', styles['f-label'], 'mb15 inline-block')}
        >
          {props.labelName}
        </label>
      ) : null}
      <div className={'relative'}>
        <select
          name={props.name}
          id="select-state"
          onChange={props.onChange}
          required={props.required}
          disabled={props.disabled}
        >
          {!props.hideEmpty ? (
            <option value="" selected={props.value}>
              Select
            </option>
          ) : null}
          {props.options.map((option, index) => {
            return (
              <option
                key={index + option.value}
                value={option.value}
                selected={isSelected(props, option)}
              >
                {option.label}
              </option>
            );
          })}
        </select>
        {props.isInvalid ? (
          <span className={styles['error']}>{props.validationMessage}</span>
        ) : null}
      </div>
    </fieldset>
  </div>
);

const TextArea = (props) => (
  <div className={cx(props.className || 'large-12 columns', styles.columns)}>
    <fieldset className={cx('f f-normal', styles['f-normal'])}>
      {props.labelName ? (
        <label className={cx('f-label full-width', styles['f-label'])}>
          {props.labelName}
        </label>
      ) : null}
      <textarea
        value={props.value}
        name={props.name}
        placeholder={props.placeholder}
        onChange={props.onChange.bind(this)}
        onBlur={props.onBlur}
        className={cx('full-width', fieldStyles['address-kyc'])}
        id={props.id}
        ref={props.inputRef}
        onFocus={props.onFocus}
        autoFocus={props.autoFocus}
        required={props.required}
        disabled={props.disabled}
        maxLength={150}
      />
      {props.isInvalid ? (
        <span className={styles['error']}>{props.validationMessage}</span>
      ) : null}
    </fieldset>
  </div>
);

const Slider = (props) => {
  let sliderRange =
    ((Number(props.value) - props.minSliderValue) /
      (props.maxSliderValue - props.minSliderValue)) *
    100;
  if (sliderRange < 0) {
    sliderRange = 0;
  } else if (sliderRange > 100) {
    sliderRange = 100;
  }
  return (
    <div
      className={cx(
        props.className || 'large-12 columns',
        styles.columns,
        'mb-30'
      )}
    >
      {props.labelName ? (
        <label className={cx('f-label', styles['f-label'], props.labelStyles)}>
          {props.labelName}
        </label>
      ) : null}
      <div
        className={`lil-mt-4 mb30 relative ${sliderStyles['slider-container']}`}
      >
        <div
          className={cx(sliderStyles['track'])}
          style={{ width: `${sliderRange}%` }}
        />
        <input
          id="slider"
          type="range"
          name={props.name}
          className={cx(sliderStyles['slider'])}
          onChange={props.onChange.bind(this)}
          min={props.minSliderValue}
          max={props.maxSliderValue}
          value={props.value}
          step={props.sliderStep}
        />
      </div>
    </div>
  );
};

const isSelected = (props, option) => {
  if (props.name === 'nameOfBank') {
    const propValueLength = props.value.length;
    const optionValueLength = option.value.length;
    if (propValueLength === optionValueLength) {
      return props.value === option.value;
    } else if (propValueLength > optionValueLength) {
      return props.value.slice(0, 3) === option.value;
    } else {
      return props.value === option.value.slice(0, 3);
    }
  }
  return props.value === option.value;
};



// WEBPACK FOOTER //
// ./components/ui/field.tsx